import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CollectionBooster } from '../../../../models/collections/collection-booster.model';
import { CollectionCardRankType } from '../../../../enums/collections/collection-card-rank-type.enum';
import { ApiCollectionsService } from '../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../services/alerts.service';
import { CollectionBoosterEditModalComponent } from '../../modals/collection-booster-edit-modal/collection-booster-edit-modal.component';

@Component({
  selector: 'app-collections-boosters-tab',
  templateUrl: './collections-boosters-tab.component.html',
  standalone: true,
  imports: [CommonModule, TooltipModule, CollectionBoosterEditModalComponent]
})
export class CollectionsBoostersTabComponent {

  @ViewChild('editModal') editModal!: CollectionBoosterEditModalComponent;

  protected readonly CollectionCardRankType = CollectionCardRankType;

  boosters: CollectionBooster[] = [];
  isLoading: boolean = false;
  readonly resultsCount: number = 25;

  constructor(
    private apiCollectionsService: ApiCollectionsService,
    private alertsService: AlertsService
  ) {}

  getTotalWeight(booster: CollectionBooster): number {
    return booster.drops.reduce((sum, d) => sum + d.rarityWeight, 0);
  }

  onClickEdit(booster: CollectionBooster): void {
    this.editModal.show(booster, () => this.refresh());
  }

  refresh(): void {
    this.isLoading = true;
    this.apiCollectionsService.getCollectionsBoosters(1, this.resultsCount).then(
      response => {
        this.isLoading = false;
        this.boosters = response.results;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading boosters : ' + error);
      }
    );
  }
}
